// Marketing site base URL — where the public pages (legal: /privacy, /terms,
// /security; plus /how-it-works, /faq, etc.) live. The app and marketing site
// are separate domains, so the app links *out* to these.
//
// Overridden at build time per environment via the VITE_MARKETING_URL Amplify
// branch var (mirrors the marketing repo's PUBLIC_APP_URL, which points the
// other way):
//   develop (dev.pricetilt.com app) -> https://staging.pricetilt.com
//   main    (app.pricetilt.com)      -> https://www.pricetilt.com
// Falls back to prod marketing when the var is unset.
export const MARKETING_URL =
  import.meta.env.VITE_MARKETING_URL || "https://www.pricetilt.com";

// Convenience builders for the legal pages linked from the app footer.
export const LEGAL_URLS = {
  privacy: `${MARKETING_URL}/privacy`,
  terms: `${MARKETING_URL}/terms`,
  security: `${MARKETING_URL}/security`,
} as const;
